/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/prop-types */
/* eslint-disable no-plusplus */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Edit, InfoRound, Plus, Attachment, Icon } from '@rsuite/icons';
import { useHistory } from 'react-router-dom';

import { MdOutlinePeopleOutline, MdOutlineVerified, MdOutlineVerifiedUser } from "react-icons/md";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

import {
  Table,
  Input,
  IconButton,
  FlexboxGrid,
  SelectPicker,
  CheckTreePicker,
  Modal,
  Checkbox,
  Button,
  CheckPicker,
} from 'rsuite';
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';
import { formatDistanceToNow } from 'date-fns';
import moment from 'moment';
import pt from 'date-fns/locale/pt-BR';
import { useDebouncedCallback } from 'use-debounce/lib';
import { Container, MetricsContainer, MetricCard, MetricIcon, MetricContent, MetricTitle, MetricValue, FiltersCard, FiltersRow, SearchWrapper, FilterSelectWrapper } from '~/styles/tabela1';
import api from '~/services/api';
import SearchInputTable from '~/components/SearchInputTable';
// import { InputDataRange } from '~/components/InputDataRange';
import { GerarCSV as CSV } from '~/utils/gerarCSV';
import { FiltroExperiencias } from '~/components/FiltroExperiencias';
import { FiltroTreinamentos } from '~/components/FiltroTreinamentos';
import SelectState from '~/components/SelectState';
import { TableHeaderTooltip, TablePagination } from '~/components/TablePagination1';
import EditarProfissional from './EditarProfissional';
import ActiveFilters from './components/ActiveFilters';
// import ProfissionalCell from './components/ProfissionalCell';
import {
  ProfissionalCell,
  BadgeCell,
  LiberacaoCell,
  LocationCell
} from './components/TableCells';
import ActionCell from './components/ActionCell';
import DetalhesCarteiraDialog from '../relatorios/CarteiraProfissionais/components/DetalhesCarteiraDialog';
import AdvancedFilters from '../../components/AdvancedFilters';
import PageHeader from '../../components/PageHeader';
import MetricsCards from '../../components/MetricCards';

const { HeaderCell, Cell } = Table;

function Profissionais() {
  const [profissionais, setProfissionais] = useState({
    lista: [],
    quantidade: 0,
  });
  const [experiencias, setExperiencias] = useState([]);
  const [experienciaSelecionada, setExperienciaSelecionada] = useState();
  const [interesses, setInteresses] = useState([]);
  const [interesseSelecionado, setInteresseSelecionado] = useState([]);
  const [perfilSelecionado, setPerfilSelecionado] = useState(false);
  const [trabalhouSimOuNao, setTrabalhouSimOuNao] = useState([]);
  const [treinamentos, setTreinamentos] = useState([]);
  const [treinamentoSelecionado, setTreinamentoSelecionado] = useState([]);
  const [cidade, setCidade] = useState('');
  const [bairro, setBairro] = useState('');
  const [estadoSelecionado, setEstadoSelecionado] = useState();
  const [ufSelecionado, setUfSelecionado] = useState();
  const [carregando, setCarregando] = useState(true);
  const [textodigitado, setTextoDigitado] = useState();
  const [pagina, setPagina] = useState(1);
  const [data, setData] = useState();
  const [atributoSelecionado, setAtributoSelecionado] = useState('nome');
  const [profissionalEditando, setProfissionalEditando] = useState();
  const [proExcluirModal, setproExcluirModal] = useState(false);
  const [modalConfirmacao, setModalConfirmacao] = useState(false);
  const [proExcluir, setproExcluir] = useState();
  const [showEditarProfissional, setShowEditarProfissional] = useState(false);
  const [exibirDetalhesDialog, setExibirDetalhesDialog] = useState({
    exibir: false,
  });
  const [buscarCSV, setBuscarCSV] = useState(false);
  const [orderBy, setOrderBy] = useState('order by Tempo de Cadastro desc');
  const [cidadeInput, setCidadeInput] = useState('');
  const [bairroInput, setBairroInput] = useState('');
  // const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const atributosFiltro = [
    {
      label: 'Nome',
      value: 'nome',
    },
    {
      label: 'Email',
      value: 'email',
    },
    {
      label: 'Cpf',
      value: 'cpf_cnpj',
    },
  ];

  const history = useHistory();

  const cidadeDebounce =
    useDebouncedCallback(setCidade, 500);

  const bairroDebounce =
    useDebouncedCallback(setBairro, 500);

  function getInteresse(status) {
    const map = {
      freelancer: 'Freelancer',
      emprego: 'Emprego',
      emprego_freelancer: 'Emprego e Freelancer',
    };

    return map[status];
  }

  const buscarProfissionais = useCallback(async () => {
    setModalConfirmacao(false);
    setCarregando(true);
    try {
      const resposta = await api.get('profissionais', {
        params: {
          [atributoSelecionado]: textodigitado,
          pagina,
          estado: estadoSelecionado,
          treinamentos: treinamentoSelecionado,
          experiencias: experienciaSelecionada,
          interesses: interesseSelecionado,
          perfil: perfilSelecionado,
          trabalhou: trabalhouSimOuNao,
          cidade,
          bairro,
          orderBy,
          csv: buscarCSV,
        },
      });

      const experienci = await api.get('profissao');
      const treinament = await api.get('treinamento');

      const newLista = experienci.data.map((map) => ({
        label: map.profissao,
        value: map.id,
      }));
      const newListaTreinamentos = treinament.data.map((map) => ({
        label: map.treinamento,
        value: map.id,
      }))
      // setTreinamentos(treinament.data);
      setTreinamentos(newListaTreinamentos);
      setExperiencias(newLista);
      // setExperiencias([
      //   {
      //     label: 'Experiencias',
      //     value: 'Todos',
      //     children: [...newLista],
      //   },
      // ]);

      const lista = resposta.data.lista.map((p) => {
        return {
          // ...item,
          ...(buscarCSV === false && p),
          Nome: p.nome,
          Email: p.email,
          Telefone: p.telefone1,
          'Cpf/Cnpj': p.cpf_cnpj,
          'Tempo de Cadastro': formatDistanceToNow(new Date(p.data_criacao), {
            locale: pt,
          }),
          Cidade: p.endereco.bairro.cidade.cidade,
          Estado: p.endereco.bairro.cidade.estado.uf,
          Bairro: p.endereco.bairro.bairro,
          Interesse: getInteresse(p.interesses),
          'Pro Liberacao': p.usr_liberacao ? p.usr_liberacao : '',
          'Dt Liberacao': p.dt_liberacao
            ? moment(p.dt_liberacao).format('DD/MM/YYYY')
            : '',
          'Resp Freela': p.contagem_registro ? p.contagem_registro : 0,
          'Resp Emprego': p.contagem_recrutamento ? p.contagem_recrutamento : 0,
          Trabalhou:
            p.contagem_recrutamento !== null || p.contagem_registro !== null
              ? 'Sim'
              : 'Não',
          'Perfil completo':
            p.id_arquivo !== null &&
              p.id_foto_perfil !== null &&
              p.id_exp_profissao !== null
              ? 'Sim'
              : 'Não',
        };
      });

      if (buscarCSV) {
        CSV({
          data: lista,
          download: true,
        });

        setCarregando(false);
        toast.success(`Foram exportados ${lista.length} registros.`);
        setBuscarCSV(false);
        return;
      }

      setProfissionais({
        quantidade: lista.length > 0 ? lista[0].full_count : 0,
        lista,
      });
      if (profissionais.quantidade === 0) setPagina(1);
    } catch (e) {
      if (buscarCSV) {
        setCarregando(false);
        toast.error('Erro ao Exportar os dados');
        setBuscarCSV(false);
        return;
      }
      toast.error(e.message);
    }
    setCarregando(false);
  }, [
    pagina,
    atributoSelecionado,
    textodigitado,
    estadoSelecionado,
    treinamentoSelecionado,
    experienciaSelecionada,
    interesseSelecionado,
    perfilSelecionado,
    trabalhouSimOuNao,
    cidade,
    bairro,
    orderBy,
    buscarCSV,
    setPagina,
    profissionais.quantidade,
  ]);

  function download(dados) {
    const blob = new Blob([dados], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('hidden', '');
    a.setAttribute('href', url);
    a.setAttribute('download', 'download.csv');
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  async function excluirPro() {
    const { id, nome } = proExcluir;
    setCarregando(true);
    setproExcluirModal(false);
    try {
      await api.delete(`profissional/${id}`);
      await buscarProfissionais();
      setCarregando(false);
      toast.success(`Profissional ${nome} excluido(a) com sucesso.`);
    } catch (e) {
      setCarregando(false);
      toast.error(e.message);
    }
  }

  useEffect(() => {
    buscarProfissionais();
  }, [buscarProfissionais]);

  function abrirEditarProfissional(profissional) {
    setProfissionalEditando(profissional);
    setShowEditarProfissional(true);
  }

  function fecharEditarProfissional() {
    buscarProfissionais();
    setShowEditarProfissional(false);
  }


  function handleDetails(rowData) {
    setExibirDetalhesDialog({
      exibir: true,
      id_profissional: rowData.id,
    });
  }

  function handleDelete(rowData) {
    setproExcluir(rowData);
    setproExcluirModal(true);
  }

  const activeFilters = useMemo(() => {
    const filters = [];

    if (cidade) {
      filters.push({
        key: 'cidade',
        label: `Cidade: ${cidade}`,
        clear: () => {
          setCidade('');
          setCidadeInput('');
        },
      });
    }

    if (bairro) {
      filters.push({
        key: 'bairro',
        label: `Bairro: ${bairro}`,
        clear: () => {
          setBairro('');
          setBairroInput('');
        },
      });
    }

    if (estadoSelecionado) {
      filters.push({
        key: 'estado',
        label: `Estado: ${ufSelecionado || estadoSelecionado}`,
        clear: () => {
          setEstadoSelecionado(undefined);
          setUfSelecionado(undefined);
        }
      });
    }

    if (treinamentoSelecionado?.length) {
      filters.push({
        key: 'treinamento',
        label: `${treinamentoSelecionado.length} treinamento(s)`,
        clear: () => setTreinamentoSelecionado([]),
      });
    }

    if (experienciaSelecionada?.length) {
      filters.push({
        key: 'experiencia',
        label: `${experienciaSelecionada.length} experiência(s)`,
        clear: () => setExperienciaSelecionada([]),
      });
    }

    if (interesseSelecionado?.length) {
      filters.push({
        key: 'interesse',
        label: `${interesseSelecionado.length} interesse(s)`,
        clear: () => setInteresseSelecionado([]),
      });
    }

    if (trabalhouSimOuNao?.length) {
      filters.push({
        key: 'trabalhou',
        label: `Já trabalhou: ${trabalhouSimOuNao}`,
        clear: () => setTrabalhouSimOuNao([]),
      });
    }

    if (perfilSelecionado) {
      filters.push({
        key: 'perfil',
        label: 'Perfil Bom',
        clear: () => setPerfilSelecionado(false),
      });
    }

    return filters;
  }, [
    cidade,
    bairro,
    estadoSelecionado,
    treinamentoSelecionado,
    experienciaSelecionada,
    interesseSelecionado,
    trabalhouSimOuNao,
    perfilSelecionado,
  ]);

  return (
    <Container>

      <PageHeader
        title="Profissionais"
        // subtitle={`Total: ${profissionais.quantidade}`}
        actions={(
          <div
            style={{
              display: 'flex',
              gap: '12px'
            }}>
            <Button
              appearance="ghost"
              startIcon={<Attachment />}
              onClick={() => setModalConfirmacao(true)}
            >
              Exportar CSV
            </Button>
            <Button
              appearance="primary"
              startIcon={<Plus />}
              onClick={() => {
                history.replace('/home/profissionais/criar')
              }}
            >
              Novo Profissional
            </Button>
          </div>
        )}
      />

      <MetricsCards
        items={[
          {
            title: 'Total de Profissionais',
            value: profissionais.quantidade,
            icon: <MdOutlinePeopleOutline size='30px' />,
            background: '#EFF6FF',
            color: '#2563EB'
          },
          {
            title: 'Quantidade de Profissionais com Perfil Completo',
            value: '-',
            icon: <MdOutlineVerified size='30px' />,
            background: '#ECFDF3',
            color: '#16A34A'
          },
          {
            title: 'Quantidade de Profissionais com Perfil Incompleto',
            value: '-',
            icon: <MdOutlineVerifiedUser size='30px' />,
            background: '#FFF7ED',
            color: '#EA580C'

          },
          {
            title: 'Operador que mais liberou profissionais',
            value: '-',
            icon: <IoMdCheckmarkCircleOutline size='30px' />,
            background: '#F3E8FF',
            color: '#7C3AED'
          },
        ]}
      />

      <AdvancedFilters
        activeFilters={activeFilters}
        header={
          <>
            <SearchInputTable
              place="Buscar profissional..."
              setTextoDigitado={setTextoDigitado}
              estilo={{ width: '700px' }}
            />

            <SelectPicker
              appearance="default"
              style={{ marginLeft: '-5px' }}
              searchable={false}
              data={atributosFiltro}
              value={atributoSelecionado}
              cleanable={false}
              onChange={setAtributoSelecionado}
            />
          </>
        }
      >
        {/* filtros */}
        <Input
          style={{ width: '250px' }}
          placeholder="Cidade"
          // onChange={cidadeDebounce.callback}
          onChange={(value) => {
            setCidadeInput(value);
            cidadeDebounce.callback(value);
          }}
          value={cidadeInput}
        />

        <Input
          style={{ width: '250px' }}
          placeholder="Bairro"
          // onChange={bairroDebounce.callback}
          onChange={(value) => {
            setBairroInput(value);
            bairroDebounce.callback(value);
          }}
          value={bairroInput}
        />

        <SelectState
          selectedState={estadoSelecionado}
          setUfSelecionado={setUfSelecionado}
          setSelectedStates={setEstadoSelecionado}
        />

        <CheckTreePicker
          placeholder="Treinamentos"
          appearance="default"
          defaultExpandAll
          style={{ width: 224 }}
          // searchable={false}
          // data={treinamentos.map((treinamento) => ({
          //   label: treinamento.treinamento,
          //   value: treinamento.id,
          // }))}
          data={treinamentos}
          value={treinamentoSelecionado}
          onChange={(value) => setTreinamentoSelecionado(value)}
        />

        <CheckTreePicker
          style={{ width: 224 }}
          // defaultExpandAll
          placeholder="Experiencias"
          appearance="default"
          data={experiencias}
          value={experienciaSelecionada}
          onChange={(value) => setExperienciaSelecionada(value)}
        />

        <CheckPicker
          appearance="default"
          searchable={false}
          placeholder="Interesse"
          data={[{
            label: 'Freelancer',
            value: 'freelancer',
          },
          {
            label: 'Emprego',
            value: 'emprego',
          },
          {
            label: 'Emprego e Freelancer',
            value: 'emprego_freelancer',
          },]}
          value={interesseSelecionado}
          onChange={(value) => setInteresseSelecionado(value)}
        />

        <SelectPicker
          appearance="default"
          searchable={false}
          placeholder="Já trabalhou"
          data={[{
            label: 'Sim',
            value: 'sim_trabalhou',
          },
          {
            label: 'Não',
            value: 'nao_trabalhou',
          },
          {
            label: 'Todos',
            value: 'todos',
          },]}
          value={trabalhouSimOuNao}
          cleanable={false}
          onChange={(value) => setTrabalhouSimOuNao(value)}
        />

        <Checkbox
          checked={perfilSelecionado}
          onChange={(bool, value) => setPerfilSelecionado(value)}
        >
          Perfil Bom
        </Checkbox>
      </AdvancedFilters>

      <FlexboxGrid style={{ width: '100%' }}>
        <TablePagination
          carregando={carregando}
          dados={profissionais.lista}
          quantidade={profissionais.quantidade}
          onChangePage={setPagina}
          setOrderBy={setOrderBy}
          wordWrap="break-word"
        >
          <Table.Column
            width={100}
          // fixed="right"
          >
            <HeaderCell align="center">
              <TableHeaderTooltip label='Ações' tooltip='Ações' />
            </HeaderCell>

            <Cell>
              {(rowData) => (
                <ActionCell
                  rowData={rowData}
                  onDetails={handleDetails}
                  onEdit={abrirEditarProfissional}
                // onDelete={handleDelete}
                />
              )}
            </Cell>
          </Table.Column>
          <Table.Column resizable width={320} sortable>
            <HeaderCell align="center">
              <TableHeaderTooltip label='Profissional' tooltip='Profissional' />
            </HeaderCell>
            <Cell dataKey="Nome">
              {(rowData) => <ProfissionalCell rowData={rowData} />}
            </Cell>
          </Table.Column>
          <Table.Column resizable width={250} sortable>
            <HeaderCell >
              <TableHeaderTooltip label='Localidade' tooltip='Localidade' />
            </HeaderCell>
            <Cell dataKey="Cidade">
              {(rowData) => <LocationCell rowData={rowData} />}
            </Cell>
          </Table.Column>
          <Table.Column resizable width={160} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Cpf/Cnpj' tooltip='Cpf/Cnpj' />
            </HeaderCell>
            <Cell dataKey="Cpf/Cnpj" />
          </Table.Column>
          <Table.Column resizable width={200} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Tempo Cadastro' tooltip='Tempo Cadastro' />
            </HeaderCell>
            <Cell dataKey="Tempo de Cadastro" />
          </Table.Column>

          <Table.Column resizable width={150}>
            <HeaderCell>
              <TableHeaderTooltip label='Trabalhou?' tooltip='Trabalhou?' />
            </HeaderCell>
            {/* <Cell dataKey="Trabalhou" /> */}
            <Cell>
              {(rowData) => (
                <BadgeCell
                  color={
                    rowData.Trabalhou === 'Sim'
                      ? '#DCFCE7'
                      : '#FEE2E2'
                  }
                  text={rowData.Trabalhou}
                />
              )}
            </Cell>
          </Table.Column>
          <Table.Column resizable width={150}>
            <HeaderCell>
              <TableHeaderTooltip label='Perfil Completo?' tooltip='Perfil Completo?' />
            </HeaderCell>
            {/* <Cell dataKey="Perfil Completo" /> */}
            <Cell>
              {(rowData) => (
                <BadgeCell
                  color={
                    rowData['Perfil completo'] === 'Sim'
                      ? '#DCFCE7'
                      : '#FEF3C7'
                  }
                  text={rowData['Perfil completo']}
                />
              )}
            </Cell>
          </Table.Column>
          <Table.Column resizable width={180}>
            <HeaderCell>
              <TableHeaderTooltip label='Interesse' tooltip='Interesse' />
            </HeaderCell>
            <Cell>
              {(rowData) => (
                <BadgeCell
                  color="#DBEAFE"
                  text={rowData.Interesse}
                />
              )}
            </Cell>
          </Table.Column>
          <Table.Column resizable width={220}>
            <HeaderCell>
              <TableHeaderTooltip label='Liberação' tooltip='Liberação' />
            </HeaderCell>

            <Cell>
              {(rowData) => (
                <LiberacaoCell rowData={rowData} />
              )}
            </Cell>
          </Table.Column>

        </TablePagination>
      </FlexboxGrid>

      <DetalhesCarteiraDialog
        exibir={exibirDetalhesDialog.exibir}
        id_profissional={exibirDetalhesDialog.id_profissional}
        datas={data}
        onFechar={() => setExibirDetalhesDialog({ exibir: false })}
      />
      <EditarProfissional
        idProfissional={profissionalEditando && profissionalEditando.id}
        showEditarProfissional={showEditarProfissional}
        setShowEditarProfissional={setShowEditarProfissional}
        fecharEditarProfissional={fecharEditarProfissional}
        atualizarLista={buscarProfissionais}
      />
      <Modal
        open={modalConfirmacao}
        onClose={() => setModalConfirmacao(false)}
        size="xs"
      >
        <Modal.Header>Gerar Relatório CSV</Modal.Header>
        <Modal.Body>
          <p>
            Deseja realmente gerar o csv dos profissionais com o filtro atual?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => setModalConfirmacao(false)}
            appearance="subtle"
          >
            Cancelar
          </Button>
          <Button
            appearance="primary"
            type="button"
            onClick={() => {
              setBuscarCSV(true);
              buscarProfissionais();
            }}
          >
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        open={proExcluirModal}
        onClose={() => setproExcluirModal(false)}
        size="xs"
      >
        <Modal.Header>Excluir Profissional</Modal.Header>
        <Modal.Body>
          <p>Deseja realmente excluir este Profissional?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setproExcluirModal(false)} appearance="subtle">
            Cancelar
          </Button>
          <Button
            appearance="primary"
            type="button"
            onClick={() => {
              excluirPro();
            }}
          >
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default Profissionais;
